import React from 'react';
import { connect } from 'react-redux';
import { Form, Select, Button, message } from 'antd';
import MultiSelect from '../../../../../components/MultiSelect';
import { contactListSelector } from '../../Contact/ContactSelectors';

const FormItem = Form.Item;
const { Option } = Select;

const PolicyMemberEdit = ({ form, contactList = [], memberContacts = [], policyRequest, addMember, close }) => {
  const { getFieldDecorator } = form;
  const contactOptions = contactList.map((contact) => (
    <Option key={contact.email} value={contact.contactId} label={`${contact.firstName} ${contact.lastName}`}>
      {contact.jobTitle
        ? `${contact.firstName} ${contact.lastName} - ${contact.jobTitle}`
        : `${contact.firstName} ${contact.lastName}`}
    </Option>
  ));

  const onSubmit = (e) => {
    e.preventDefault();
    form.validateFields(async (err, values) => {
      if (err) return;

      const selectedIds = new Set((values.contacts || []).map(String));
      const addedMemberContacts = contactList.filter((contact) => selectedIds.has(String(contact.contactId)));
      if (!addedMemberContacts.length) {
        message.warning('Select at least one accountable member.');
        return;
      }

      try {
        await Promise.resolve(addMember(addedMemberContacts));
        close();
      } catch {
        // Parent shows the error toast; keep the modal open so the user can retry.
      }
    });
  };

  return (
    <Form>
      <FormItem>
        {getFieldDecorator('contacts', {
          initialValue: (memberContacts || []).map((item) => item.contactId),
          rules: [{ required: true, message: 'Select at least one accountable member.' }],
        })(
          <MultiSelect
            placeholder="Add member"
            disabled={policyRequest}
            showSearch
            notFoundContent="Not Found"
            filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
            optionFilterProp="children"
            optionLabelProp="label"
            dropdownMatchSelectWidth={false}
            dropdownStyle={{ minWidth: 320 }}
            dropdownMenuStyle={{ maxHeight: 360, overflowY: 'auto' }}
          >
            {contactOptions}
          </MultiSelect>,
        )}
      </FormItem>
      <FormItem>
        <Button type="primary" block loading={policyRequest} onClick={onSubmit}>
          {policyRequest ? 'Saving' : 'Save'}
        </Button>
      </FormItem>
    </Form>
  );
};

const mapStateToProps = (state) => ({
  contactList: contactListSelector(state),
  policyRequest: state.policyReducer.policyRequest,
});

export default connect(mapStateToProps)(Form.create()(PolicyMemberEdit));
